var _path, _circle, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPokeball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.91188e-05 15.9999C-2.89351e-05 13.8988 0.41382 11.8182 1.21789 9.877C2.02196 7.9358 3.2005 6.17199 4.68623 4.68626C6.17196 3.20053 7.93577 2.02199 9.87697 1.21792C11.8182 0.413851 13.8987 2.23226e-06 15.9999 2.41594e-06C18.101 2.59963e-06 20.1816 0.413852 22.1228 1.21792C24.064 2.02199 25.8278 3.20054 27.3135 4.68626C28.7992 6.17199 29.9778 7.93581 30.7818 9.877C31.5859 11.8182 31.9998 13.8988 31.9998 15.9999L15.9999 15.9999L-2.91188e-05 15.9999Z",
    fill: "#F33C3C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0004,
    cy: 15.9999,
    r: 15.2499,
    stroke: "#F33C3C",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9999,
    r: 5.06814,
    fill: "white",
    stroke: "#F33C3C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9095 15.9999H0.000488281",
    stroke: "#F33C3C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999L21 15.9999",
    stroke: "#F33C3C",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPokeball);
export default __webpack_public_path__ + "static/media/icon-pokeball.d3166f4c8d49c4e87a97331dbe25ef97.svg";
export { ForwardRef as ReactComponent };